import { useState, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getName } from "country-list";

import { fetchAllEntites } from "../../../Pages/MyEntityDashboard/myEntityDashboardSlice";
import {
  fetchAddress,
  fetchCities,
  fetchStates,
  editAddress,
  addAddress,
  deleteAddress,
} from "./addressesSlice";

let newaddress = {
  id: Math.floor(Math.random() * 100),
  type: "",
  country: "",
  address_line_1: "",
  address_line_2: "",
  state: "",
  city: "",
  postalcode: "",
  stateOptions: [],
  cityOptions: [],
};
function isPlainObject(value) {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
function normalizeCountry(value) {
  if (typeof value !== "object" || value === null || Array.isArray(value)) {
    return {
      name: value && getName(value),
      code: value,
    };
  }
  return value;
}
const useEditAddress = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [registerAddress, setRegisterAddress] = useState(null);
  const [tradingAddress, setTradingAddress] = useState(null);
  const [physicalAddress, setPhysicalAddress] = useState(null);
  const [isEditingEnabled, setIsEditingEnabled] = useState(false);
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdateLoading, setUpdateIsLoading] = useState(false);
  const [isTradeAvailable, setIsTradeAvailable] = useState(false);
  const [isPhysicalAvailable, setIsPhysicalAvailable] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [entityConfigEnable, setEntityConfigEnable] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [deletemodal, setDeleteModal] = useState(false);
  const [addressSelect, setAddressSelect] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [isRemoving, setIsRemoving] = useState(false);
  const [defaultRegAddress, setDefaultRegAddress] = useState({});
  const [defaultTradeAddress, setDefaultTradeAddress] = useState({});
  const [defaultPhysicalAddress, setDefaultPhysicalAddress] = useState({});

  const [newAddress, setNewAddress] = useState({});

  const currentAddress = useSelector(
    (state) => state.addresses?.currentAddress?.data || [],
  );

  const { generalInformation, status } = useSelector(
    (state) => state.generalInformation,
  );

  useEffect(() => {
    let isEnable = generalInformation?.data?.entity_plus_config;
    setEntityConfigEnable(isEnable ? true : false);
  }, [generalInformation]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        await Promise.all([
          dispatch(fetchAddress(id)),
          dispatch(fetchAllEntites()),
        ]);
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false);
      }
    };
    fetchData();
  }, [dispatch, id]);

  useEffect(() => {
    if (currentAddress.length > 0) {
      const registerdata = currentAddress.find(
        (address) => address.type === "Registered",
      );
      const tradedata = currentAddress.find(
        (address) => address.type === "Trading",
      );
      const physicaldata = currentAddress.find(
        (address) => address.type === "Physical",
      );

      if (tradedata) {
        setIsTradeAvailable(true);
      } else {
        setIsTradeAvailable(false);
      }
      if (physicaldata) {
        setIsPhysicalAvailable(true);
      } else {
        setIsPhysicalAvailable(false);
      }

      handleRegisterInitial(registerdata);
      handleTradingInitial(tradedata);
      handlePhysicalInitial(physicaldata);
    }
    if (currentAddress.length === 2) {
      const allTypes = ["Registered", "Physical", "Trading"];
      const usedTypes = currentAddress.map((item) => item.type);
      const missingType = allTypes.find((t) => !usedTypes.includes(t));
      setNewAddress({ ...newaddress, type: missingType });
    } else {
      setNewAddress(newaddress);
    }
    if (currentAddress.length > 0) {
      setIsLoading(false);
    }
  }, [currentAddress]);

  const handleTradingInitial = (data) => {
    const country = normalizeCountry(data?.country);
    setTradingAddress(data);
    setDefaultTradeAddress(data);
    handleCountry(country, setTradingAddress, true, data);
    handleCountry(country, setDefaultTradeAddress, true, data);
  };

  const handleRegisterInitial = (data) => {
    const country = normalizeCountry(data?.country);
    setRegisterAddress(data);
    setDefaultRegAddress(data);
    handleCountry(country, setRegisterAddress, true, data);
    handleCountry(country, setDefaultRegAddress, true, data);
  };

  const handlePhysicalInitial = (data) => {
    const country = normalizeCountry(data?.country);
    setPhysicalAddress(data);
    setDefaultPhysicalAddress(data);
    handleCountry(country, setPhysicalAddress, true, data);
    handleCountry(country, setDefaultPhysicalAddress, true, data);
  };

  const handleCountry = async (
    value,
    setFunction,
    cityUpdate = false,
    data = {},
  ) => {
    setFunction((prev) => ({
      ...prev,
      stateLoader: true,
      cityLoader: true,
    }));
    const countrycode = value.code;
    const stateRes = await dispatch(fetchStates(countrycode)).unwrap();
    const stateOptions = stateRes.map((state) => ({
      name: state.label,
      code: state.value,
    }));

    if (cityUpdate) {
      let stateValue = data?.state
        ? stateOptions.find((x) => x.code === data?.state)
        : null;

      const cityRes =
        data?.state &&
        (await dispatch(fetchCities([countrycode, data?.state])).unwrap());

      const cityOptions =
        data?.state &&
        cityRes?.map((city) => ({
          name: city.label,
          code: city.value,
        }));

      let cityValue = data?.city
        ? cityOptions.find((x) => x.code === data?.city)
        : null;

      setFunction((prev) => ({
        ...prev,
        stateOptions,
        state: stateValue,
        cityOptions: cityOptions || [],
        city: cityValue,
        country: value,
        stateLoader: false,
        cityLoader: false,
      }));
    } else {
      setFunction((prev) => ({
        ...prev,
        state: null,
        city: null,
        stateOptions,
        cityOptions: [],
        country: value,
        stateLoader: false,
        cityLoader: false,
      }));
    }
  };
  const handleState = async (value, countrycode, setFunction) => {
    const stateCode = value.code;
    if (countrycode && stateCode) {
      const cityRes = await dispatch(
        fetchCities([countrycode, stateCode]),
      ).unwrap();
      const cityOptions = cityRes.map((city) => ({
        name: city.label,
        code: city.value,
      }));

      setFunction((prev) => ({
        ...prev,
        state: value,
        city: null,
        cityOptions,
      }));
    }
  };

  const handleEditClick = () => {
    setIsEditingEnabled(!isEditingEnabled);
  };

  function validNumber(x) {
    const out = /^(?!\s*$)[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$/.test(x || "");
    return out;
  }
  const handleValidateFields = (item) => {
    if (
      !item.country ||
      !item.country.name ||
      !item.country.code ||
      !item.type?.trim() ||
      !item.address_line_1?.trim() ||
      !item.postalcode?.trim() ||
      !validNumber(item.postalcode)
    ) {
      return false;
    }
    return true;
  };

  function compareObjects(obj1, obj2) {
    if (obj1 == null || obj2 == null) return false;
    for (const key in obj1) {
      if (Object.prototype.hasOwnProperty.call(obj1, key)) {
        if (typeof obj1[key] === "object" && obj1[key] !== null) {
          if (!compareObjects(obj1[key], obj2?.[key])) {
            return false;
          }
        } else {
          if (obj1[key] !== obj2?.[key]) {
            return false;
          }
        }
      }
    }
    return true;
  }

  const comparedata = (data) => {
    let obj = {
      id: data?.id,
      country: data?.country,
      address_line_1: data?.address_line_1 || "",
      address_line_2: data?.address_line_2,
      state: data?.state || "",
      city: data?.city || "",
      postalcode: data?.postalcode || "",
    };
    return obj;
  };

  const handleSave = (data) => {
    setUpdateIsLoading(true);
    const payload = {
      id: data.id,
      country: data?.country.code || "",
      address_line_1: data?.address_line_1 || "",
      address_line_2: data?.address_line_2 || "",
      city: data?.city?.name || "",
      state: data?.state?.code || "",
      postalcode: data?.postalcode || "",
    };
    dispatch(editAddress(payload)).then(() => {
      setIsEditingEnabled(false);
      setSuccessMsg("Address updated");
      handleHideNotification();
      setUpdateIsLoading(false);
      setIsLoading(true);
      setDefaultRegAddress({});
      setDefaultTradeAddress({});
      setDefaultPhysicalAddress({});
      dispatch(fetchAddress(id)).then(() => {
        setIsLoading(false);
      });
    });
  };

  const handleHideNotification = () => {
    setTimeout(() => {
      setSuccessMsg("");
    }, 5000);
  };
  const handleChangeTab = (v) => {
    setIsEditingEnabled(false);
    setIsSaveEnabled(false);
    setUpdateIsLoading(false);
    setSuccessMsg("");
    handleTradeDiscard();
    handleRegisterDiscard();
    setActiveTab(v);
    handleRemoveClose();
  };

  const isSaveEnabledRegistered = useMemo(() => {
    if (!defaultRegAddress || !registerAddress) return false;
    const isIdentical = compareObjects(
      comparedata(defaultRegAddress),
      comparedata(registerAddress),
    );
    const country = normalizeCountry(registerAddress.country);
    return (
      isIdentical || !handleValidateFields({ ...registerAddress, country })
    );
  }, [defaultRegAddress, registerAddress]);

  const RegisterAddressOnchange = async (e) => {
    const { name, value } = e.target;
    setRegisterAddress((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (name === "country") {
      handleCountry(value, setRegisterAddress);
    }
    if (name === "state") {
      const countryCode = registerAddress?.country?.code;
      handleState(value, countryCode, setRegisterAddress);
    }
  };

  const handleRegisterDiscard = () => {
    const obj = currentAddress.find((address) => address.type === "Registered");
    handleRegisterInitial(obj);
    setIsEditingEnabled(false);
  };

  const handleRegisterSave = () => {
    handleSave(registerAddress);
  };

  const handleTradeDiscard = () => {
    const obj = currentAddress.find((address) => address.type === "Trading");
    handleTradingInitial(obj);
    setIsEditingEnabled(false);
  };

  const tradeAdressOnchange = async (e) => {
    const { name, value } = e.target;
    setTradingAddress((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (name === "country") {
      handleCountry(value, setTradingAddress);
    }
    if (name === "state") {
      const countryCode = tradingAddress?.country?.code;
      handleState(value, countryCode, setTradingAddress);
    }
  };

  const isSaveEnabledTrade = useMemo(() => {
    if (!defaultTradeAddress || !tradingAddress) return false;
    const isIdentical = compareObjects(
      comparedata(defaultTradeAddress),
      comparedata(tradingAddress),
    );
    const country = normalizeCountry(tradingAddress.country);
    return isIdentical || !handleValidateFields({ ...tradingAddress, country });
  }, [defaultTradeAddress, tradingAddress]);

  const handleTradeSave = () => {
    handleSave(tradingAddress);
  };

  const handlePhysicalSave = () => {
    handleSave(physicalAddress);
  };
  const handlePhysicalDiscard = () => {
    const obj = currentAddress.find((address) => address.type === "Physical");
    handlePhysicalInitial(obj);
    setIsEditingEnabled(false);
  };
  const physicalAdressOnchange = async (e) => {
    const { name, value } = e.target;
    setPhysicalAddress((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (name === "country") {
      handleCountry(value, setPhysicalAddress);
    }
    if (name === "state") {
      const countryCode = physicalAddress?.country?.code;
      handleState(value, countryCode, setPhysicalAddress);
    }
  };

  const isSaveEnabledPhysical = useMemo(() => {
    if (!defaultPhysicalAddress || !physicalAddress) return false;
    const isIdentical = compareObjects(
      comparedata(defaultPhysicalAddress),
      comparedata(physicalAddress),
    );
    const country = normalizeCountry(physicalAddress.country);
    return (
      isIdentical || !handleValidateFields({ ...physicalAddress, country })
    );
  }, [defaultPhysicalAddress, physicalAddress]);

  const handleNewToggle = (id, type) => {
    setNewAddress((prev) => ({
      ...prev,
      type,
    }));
  };
  const handleNewAddress = (e) => {
    const { name, value } = e.target;
    setNewAddress((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (name === "country") {
      handleCountry(value, setNewAddress);
    }
    if (name === "state") {
      const countryCode = newAddress?.country?.code;
      handleState(value, countryCode, setNewAddress);
    }
  };
  const handleNewDiscard = () => {
    setNewAddress(newaddress);
  };
  const saveNewAddress = () => {
    setUpdateIsLoading(true);

    const payload = {
      data: {
        ...newAddress,
        country: newAddress?.country?.code,
        city: newAddress?.city?.name,
        state: newAddress?.state?.code,
      },
      id,
    };
    dispatch(addAddress(payload, id)).then(() => {
      setIsEditingEnabled(false);
      setSuccessMsg("Address added successfully");
      handleHideNotification();
      setUpdateIsLoading(false);
      setIsLoading(true);
      setDefaultRegAddress({});
      setDefaultTradeAddress({});
      setDefaultPhysicalAddress({});
      dispatch(fetchAddress(id)).then(() => {
        setIsLoading(false);
        setActiveTab(0);
        handleRemoveClose();
      });
    });
  };

  const isEnableNewAddress = useMemo(() => {
    return !handleValidateFields(newAddress);
  }, [newAddress]);

  const removeAddress = () => {
    setIsRemoving(true);
    dispatch(deleteAddress(deleteId)).then(() => {
      setIsEditingEnabled(false);
      handleHideNotification();
      setDefaultRegAddress({});
      setDefaultTradeAddress({});
      setDefaultPhysicalAddress({});
      dispatch(fetchAddress(id)).then(() => {
        setActiveTab(0);
        handleRemoveClose();
      });
    });
  };

  const handleRemoveAdd = (type, id) => {
    setAddressSelect(type);
    setDeleteModal(true);
    setDeleteId(id);
  };

  const handleRemoveClose = () => {
    setDeleteModal(false);
    setAddressSelect("");
    setDeleteId("");
    setIsRemoving(false);
  };
  return {
    state: {
      activeTab,
      registerAddress,
      tradingAddress,
      physicalAddress,
      isUpdateLoading,
      successMsg,
      isEditingEnabled,
      isLoading,
      isSaveEnabled,
      isTradeAvailable,
      isPhysicalAvailable,
      newAddress,
      isEnableNewAddress,
      entityConfigEnable,
      deletemodal,
      addressSelect,
      isRemoving,
      isSaveEnabledRegistered,
      isSaveEnabledTrade,
      isSaveEnabledPhysical,
      isEntityLoading: status == "succeeded",
    },
    handleEditClick,
    handleRegisterDiscard,
    handleRegisterSave,
    RegisterAddressOnchange,
    handleChangeTab,
    handleTradeDiscard,
    tradeAdressOnchange,
    handleTradeSave,
    physicalAdressOnchange,
    handlePhysicalDiscard,
    handlePhysicalSave,
    handleNewToggle,
    handleNewAddress,
    saveNewAddress,
    handleNewDiscard,
    handleRemoveAdd,
    handleRemoveClose,
    removeAddress,
  };
};
export default useEditAddress;
